module.exports = __webpack_public_path__ + "static/06-a0f7a859d8fc4abd1b6a4b699847cd5a.jpg";